import { Routes } from '@angular/router';

import { MpsAdminGuard } from '../mps/guards/mps-admin.guard';
import { MpsCylinderManagementGuard } from '../mps/guards/mps-cylinder-management.guard';
import { MpsStoGuard } from '../mps/guards/mps-sto.guard';
import { MpsUserManagementGuard } from '../mps/guards/mps-user-management.guard';
import { applicationRouteNames } from './application-route-names';
import { MpsIncidentManagementGuard } from '../mps/guards/mps-incident-management.guard';

export const applicationRoutes: Routes = [
  {
    path: applicationRouteNames.cylinderManagement,
    loadChildren: () => import('./domain/lpg-cylinder-management/lpg-cylinder-management.routes')
      .then((m) => m.lpgCylinderManagementRoutes),
    data: { title: 'general.navigation.cylinder_management' },
    canActivate: [MpsCylinderManagementGuard],
    canLoad: [MpsCylinderManagementGuard],
  },
  {
    path: applicationRouteNames.sto,
    loadChildren: () => import('./domain/lpg-sto/lpg-sto.routes').then((m) => m.lpgStoRoutes),
    data: { title: 'general.navigation.sto' },
    canActivate: [MpsStoGuard],
    canLoad: [MpsStoGuard],
  },
  {
    path: applicationRouteNames.incidentManagement,
    loadChildren: () => import('./domain/lpg-incident-management/lpg-incident-management.routes')
      .then((m) => m.lpgIncidentManagementRoutes),
    data: { title: 'general.navigation.incident_management' },
    canActivate: [MpsIncidentManagementGuard],
    canLoad: [MpsIncidentManagementGuard],
  },
  {
    path: applicationRouteNames.admin,
    loadChildren: () => import('./domain/lpg-admin/lpg-admin.routes').then((m) => m.lpgAdminRoutes),
    data: { title: 'general.navigation.admin' },
    canActivate: [MpsAdminGuard],
    canLoad: [MpsAdminGuard],
  },
  {
    path: applicationRouteNames.userManagement,
    loadChildren: () => import('./domain/lpg-user-management/lpg-user-management.routes')
      .then((m) => m.lpgUserManagementRoutes),
    canActivate: [MpsUserManagementGuard],
    canLoad: [MpsUserManagementGuard],
    data: { title: 'general.navigation.user_management' },
  }
];
